// const prettifyMoney = function (n) {
//     number = parseFloat(n)/10.0;
//     return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
// }

// module.exports = {
//     prettifyMoney
//   }

function prettifyMoney(n) {
    number = parseFloat(n)/100.0;
    return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

window.prettifyMoney = prettifyMoney;